import _get from 'lodash/get';
/**
 *
 * @module ScriptLoader
 * @desc
 * @class ScriptLoader
 *
 */
class ScriptLoader {

    static getAPI(scriptUrl, scriptLocation) {

        return new Promise((resolve, reject) => {

            const script = document.createElement("script");
            const exists = document.querySelector(`[src="${scriptUrl}"]`);

            script.src = scriptUrl;
            script.onload = function() {

                const scriptObj = _get(window, scriptLocation);

                if (scriptObj) {

                    return resolve(scriptObj);

                } else {

                    return reject(new Error(`Could not load script ${scriptUrl}`));

                }

            };

            if(!exists) {

                script.onerror = reject;
                script.type = "text/javascript";

                document.getElementsByTagName("body")[0].appendChild(script);

            }

        });

    }

}

export default ScriptLoader;
